import  { FC } from 'react';
import { useQuery } from "@apollo/client";
import { CountryDropdown } from './country-dropdown';
import { lookupCountryQuery } from './country-dropdown-query'
import { ComponentQueryLoader } from '../component-query-loader';
import { Rule} from 'antd/es/form';
type RawValueType = string | number;
interface LabelInValueType {
    label: React.ReactNode;
    value: RawValueType;
    /** @deprecated `key` is useless since it should always same as `value` */
    key?: React.Key;
  }
 export interface CountryDropdownContainerProps {
  isCreditCardDetails?: boolean;
  isCitizenship?: boolean;
  isPrimaryEducation?: boolean;
  handleOnChange?: () => void;
  name?: string | (string | number)[];
  rules?: Rule[]
  label?: string;
  placeholder?: string;
  style?: React.CSSProperties;
  showSearch?: boolean;
  optionFilterProp?: string;
  labelRender?: (labelInValue: LabelInValueType) => React.ReactNode;
  countryData?: Array<{ countryCode: string; countryName: string }>;
  selectedCitizenship?: string[];
  onChange?: (value: string) => void;
  allCountryData?: any;
  disabled?: boolean;
}
export const CountryDropdownContainer: FC<CountryDropdownContainerProps> = (props) => {
    const { data: countryInfo , loading: countryLoading, error: countryError} = useQuery(lookupCountryQuery, {
        context: { clientName: 'unauthorized' }
      });
  console.log('countryInfo', countryInfo);
 return (
    <ComponentQueryLoader 
    loading={countryLoading}
    error={countryError}
    hasData={countryInfo?.countries?.eventPayload?.countries}
    hasDataComponent={<CountryDropdown 
          {...props}
          allCountryData = {countryInfo?.countries?.eventPayload?.countries}/>}
    />

 );
}
